/* import __COLOCATED_TEMPLATE__ from './success-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();